import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { DealerBrandingDbService } from "../services/dealer-branding-db.service";
import { EntityDbService } from "../services/entity-db.service";
import { EntityInfoDbService } from "../services/entityinfo-db.service";
import { EntityInfoTypeDbService } from "../services/entityinfo-type-db.service";
import { DealerBrandingEffects, EntityEffects, EntityInfoEffects, EntityInfoTypeEffects } from "./effects";
import { dealerBrandingReducer, entityInfosReducer, reducer } from "./reducers";

@NgModule({
    imports: [
        CommonModule,
        MatSnackBarModule,
        MatDialogModule,
        StoreModule.forFeature("entity", reducer),
        StoreModule.forFeature("entityinfos", entityInfosReducer),
        StoreModule.forFeature("dealerBranding", dealerBrandingReducer),
        EffectsModule.forFeature([EntityEffects, EntityInfoTypeEffects, EntityInfoEffects, DealerBrandingEffects]),
    ],
    providers: [
        EntityEffects,
        EntityInfoTypeEffects,
        EntityInfoTypeDbService,
        EntityDbService,
        EntityInfoDbService,
        EntityInfoEffects,
        DealerBrandingEffects,
        DealerBrandingDbService,
    ],
})
export class EntityStoreModule {}
